let API_URL: string;

if (process.env.REACT_APP_ENVIRONMENT === "development") {
  // Local development
  API_URL = "http://localhost:8083/api";
} else {
  API_URL = "https://parqueo-api.sojoj.com/api";
}

export { API_URL };
